import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getPointsActivities } from '@/app/shared/services/api';
import { PointsActivity } from '@/app/shared/services/api/types';

export interface UsePointsActivitiesReturn {
  rows: PointsActivity[];
  isLoading: boolean;
  refetch: () => void;
}

export const usePointsActivities = (): UsePointsActivitiesReturn => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.POINTS_ACTIVITIES],
    queryFn: () => getPointsActivities(),
  });

  return {
    rows: data?.rows ?? [],
    isLoading,
    refetch,
  };
};
